package com.trevorwiebe.timesheet.core.domain.dto

import com.trevorwiebe.timesheet.core.domain.model.TimeOffRequestModel
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class TimeOffRequestDto(
    val employeeId: String?,
    val requestOffTime: LocalDate,
    val approved: Boolean?,
    val reviewedDate: LocalDate?,
    val requestSubmittedDateTime: LocalDateTime
) {
    fun toTimeOffRequestModel(id: String): TimeOffRequestModel {
        return TimeOffRequestModel(
            id = id,
            employeeId = employeeId,
            requestOffTime = requestOffTime,
            approved = approved,
            reviewedDate = reviewedDate,
            requestSubmittedDateTime = requestSubmittedDateTime
        )
    }
}
